import { render, staticRenderFns } from "./FAQAgent.vue?vue&type=template&id=cb3a0df2&scoped=true&"
import script from "./FAQAgent.vue?vue&type=script&lang=js&"
export * from "./FAQAgent.vue?vue&type=script&lang=js&"
import style0 from "./FAQAgent.vue?vue&type=style&index=0&id=cb3a0df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3a0df2",
  null
  
)

export default component.exports